export const frequentActivities: any[] = [
  {
    path: '/clients',
    icon: 'user',
    toolTip: 'Clients'
  },
  {
    path: '/groups',
    icon: 'users',
    toolTip: 'Groups'
  },
  {
    path: '/centers',
    icon: 'building',
    toolTip: 'Centers'
  },
  {
    path: '/accounting',
    icon: 'money-bill-alt',
    toolTip: 'Accounting'
  },
  {
    path: '/reports',
    icon: 'chart-bar',
    toolTip: 'Reports'
  },
  {
    path: '/appusers',
    icon: 'users',
    toolTip: 'Users'
  },
  {
    path: '/organization',
    icon: 'id-badge',
    toolTip: 'Organization'
  },
  {
    path: '/system',
    icon: 'cog',
    toolTip: 'System'
  },
  {
    path: '/products',
    icon: 'book',
    toolTip: 'Products'
  },
  {
    path: '/templates',
    icon: 'address-card',
    toolTip: 'Templates'
  }
];
